import { env, IEnvironment } from './environment-types';

export const environment: IEnvironment = env({
	production: false,
	name: 'stage',
});
